import numbro from 'numbro'

export const withSign = (num: number) => {
  if (num <= 0) {
    return `${num}`
  }
  return `+${num}`
}

// https://realadvisor.github.io/rifm/

export const NUMBER_ACCEPT_REGEX = /[\d.]+/g

const parseNumber = (string: string) =>
  (string.match(NUMBER_ACCEPT_REGEX) || []).join('')

export const formatFloatingPointNumber =
  (maxDigits: number) => (value: string) => {
    const parsed = parseNumber(value)
    const [head, tail] = parsed.split('.')
    // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
    // must not to convert it to 1.24, it must stay 1.23
    // eslint-disable-next-line unicorn/no-null
    const scaledTail = tail == null ? '' : tail.slice(0, maxDigits)

    const number = Number.parseFloat(`${head}.${scaledTail}`)

    if (Number.isNaN(number)) {
      return '0'
    }

    const formatted = number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: maxDigits,
    })

    if (parsed.includes('.')) {
      const [formattedHead] = formatted.split('.')

      // skip zero at digits position for non fixed floats
      // as at digits 2 for non fixed floats numbers like 1.50 has no sense, just 1.5 allowed
      // but 1.0 has sense as otherwise you will not be able to enter 1.05 for example
      const formattedTail =
        scaledTail !== '' && scaledTail[maxDigits - 1] === '0'
          ? scaledTail.slice(0, -1)
          : scaledTail

      return `${formattedHead}.${formattedTail}`
    }
    return formatted
  }

export const INTEGER_ACCEPT = /\d+/g

const parseInteger = (string: string) =>
  (string.match(INTEGER_ACCEPT) || []).join('')

export const formatInteger = (string: string) => {
  const parsed = parseInteger(string)
  const number = Number.parseInt(parsed, 10)
  if (Number.isNaN(number)) {
    return ''
  }
  return number.toLocaleString('en-US')
}

export const formatCount = (count: number) =>
  numbro(count).format({ thousandSeparated: true })
